import moment from 'moment'
import styled from 'styled-components'
import Month from './Month'

function makeCalendarFormat(attendaceList = [], studentId) {
    if (!!!attendaceList.length) return []

    let displayArray = []

    attendaceList.forEach((month) => {
        let nameOfMonth = moment(month.date?.toDate()).format('MMMM YYYY')
        let sortedKeys = Object.keys(month).sort()

        let attendance = {}
        sortedKeys.forEach((el) => {
            if (el === 'date' || el === 'batch') return

            if (!(studentId in month?.[el])) return

            let dayKey = moment(month?.[el].date?.toDate()).format('D')
            attendance[dayKey] = month?.[el]?.[studentId]
        })
        if (!!Object.keys(attendance).length)
            displayArray.push({
                nameOfMonth,
                date: month.date?.toDate(),
                attendance
            })
    })

    return displayArray
}

export default function Calendar({ fetchList, studentId }) {
    let dataInFormat = makeCalendarFormat(fetchList, studentId)

    return (
        <div style={{ width: '100%' }}>
            {(!!dataInFormat.length &&
                dataInFormat.map((el, index) => (
                    <Month key={index} monthInfo={el} />
                ))) || <NotAvailable>No Attendance Found</NotAvailable>}
        </div>
    )
}

const NotAvailable = styled.div`
    text-align: center;
    color: #fff;
    margin: 30px 0;
`
